import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withApollo } from 'react-apollo';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import AccountAvatar from '../../sections/Account/Avatar';
import { Text, FlexContainer, Icon, Loading, Row } from '../../common';
import { device } from '../../../utils/breakpoints';
import { generateTraceabilityUtil } from '../../../utils/misc';
import adfsAuth from '../../../utils/adfsAuth';
import { Tooltip } from 'antd';

const Container = styled.div`
  display: none;
  width: 100%;
  padding: 0px 20px;
  @media ${device.tablet} {
    display: flex;
  }
`;

const PageTitle = styled(Text)`
  padding-right: 7px;
`;

const Header = ({ CenterHeaderComponent, RightHeaderComponent, LeftHeaderComponent, sidebarOpened, location, client }) => {
    const [loading, setLoading] = useState(false);
    const [soundEnabled, setSoundEnabled] = useState(JSON.parse(localStorage.getItem('soundEnabled')));

    let path = location.pathname;

    if (path.match(/\/orders\/(.{1,})/)) {
        path = '/orders/:id';
    }

    const onLogout = async () => {
        setLoading(true);
        await generateTraceabilityUtil(client, { actionId: 7 });

        adfsAuth.logout(() => {
            sessionStorage.clear();
            window.location.href = '/';
        });
    };

    const handleDisableSound = () => {
        localStorage.setItem('soundEnabled', JSON.stringify(!soundEnabled));
        setSoundEnabled(!soundEnabled)
    };

    const soundEnabledAux = soundEnabled || soundEnabled === null;

    return (
        <Container>
            <FlexContainer flex='1' align='center'>
                <>
                    <PageTitle
                        size={20}
                        text={`router.pathname:${path}`}
                    />
                </>
                <CenterHeaderComponent />
            </FlexContainer>
            <FlexContainer align='center'>
                <RightHeaderComponent />
                <Tooltip placement='top' title={soundEnabledAux ? 'Desactivar sonido de notificaciones' : 'Activar sonido de notificaciones'}>
                    <Row width={40} height={34}>
                        <Icon
                            style={{ marginTop: 3, alignContent: 'center' }}
                            name={soundEnabledAux ? 'sound-active' : 'sound-off'}
                            color={soundEnabledAux ? '#1fa02e' : '#666666'}
                            size={22}
                            left={10}
                            onClick={handleDisableSound}
                            pointer />
                    </Row>
                </Tooltip>
                <AccountAvatar />
                {loading
                    ? <Loading loading={loading} style={{ marginLeft: 10 }} />
                    : <Icon name='logout' color='#1fa02e' size={24} left={10} onClick={onLogout} pointer />
                }
            </FlexContainer>
        </Container>
    );
};

Header.propTypes = {
    CenterHeaderComponent: PropTypes.any,
    LeftHeaderComponent: PropTypes.any,
    RightHeaderComponent: PropTypes.any,
    sidebarOpened: PropTypes.bool,
    match: PropTypes.object,
    client: PropTypes.object,
    location: PropTypes.object
};

Header.defaultProps = {
    sidebarOpened: false,
    RightHeaderComponent: () => (null),
    CenterHeaderComponent: () => (null),
    LeftHeaderComponent: () => (
        <div >
            <span>Header</span>
        </div>
    )
};

export default withApollo(withRouter(Header));
